import React, { useRef } from "react";
import Autoplay from 'embla-carousel-autoplay';
import CardServicosCompacto from "./cardServicosCompacto";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";
import {
    Carousel,
    CarouselButtonsMobile,
    CarouselContent,
    CarouselItem,
} from './carousel';
import Container from './container';

export default function CardsAms({ cards = [] }) {
    const { openModal } = useModal();
    const scrollRef = useRef(null);
    
    return (
        <div className="w-full py-12 md:py-24 bg-[#040116] bg-[url('/assets/servicos/banner-cards-ams.png')] bg-cover bg-top bg-no-repeat">
            <Container className="text-white space-y-8">
                <h2 className="font-inter-light text-center text-2xl md:text-4xl mb-4 md:mb-8 md:px-40 leading-tight md:leading-12 pb-4 md:pb-8">
                    Parceria completa e estratégica entre <br className="hidden md:block" />
                    <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]">
                        a nossa equipe e a sua
                    </span>
                    .
                </h2>
                
                {/* Desktop view - same as original */}
                <div className="hidden md:flex md:flex-wrap md:justify-center md:gap-4 md:pb-8">
                    {cards.map((card, index) => (
                        <CardServicosCompacto
                            key={index}
                            title={card.title}
                            text={card.text}
                            icon={card.icon}
                            iconHover={card.iconHover || card.icon}
                            glowColor={card.glowColor || "#FC0021"}
                            width={card.width}
                            height={card.height}
                            iconBgColor="#11112E"
                        />
                    ))}
                </div>
                
                {/* Mobile view - carousel like cardsFinops */}
                <div ref={scrollRef} className="md:hidden">
                    <Carousel
                        plugins={[
                            Autoplay({
                                delay: 4000,
                            }),
                        ]}
                        className="overflow-visible"
                    >
                        <CarouselContent className="py-2">
                            {cards.map((card, index) => (
                                <CarouselItem key={index} className="">
                                    <div className="flex justify-center w-full">
                                        <CardServicosCompacto
                                            key={index}
                                            title={card.title}
                                            text={card.text}
                                            icon={card.icon}
                                            iconHover={card.iconHover || card.icon}
                                            glowColor={card.glowColor || "#FC0021"}
                                            width="350"
                                            height="196"
                                            iconBgColor="#11112E"
                                            className="mx-auto scale-90"
                                        />
                                    </div>
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                        <CarouselButtonsMobile />
                    </Carousel>
                </div>

                <div className="flex justify-center pt-4 md:pt-0">
                    <button
                        onClick={() => openModal(<FormularioRD />)}
                        className="font-inter-bold bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB] rounded-full py-3 px-8 text-white font-medium hover:scale-105 transition-transform duration-300 cursor-pointer"
                    >
                        Faça parte do Programa
                    </button>
                </div>
            </Container>
        </div>
    );
}
